import { createReducer } from '@reduxjs/toolkit';

let price = 0;
const gold_buy_price = createReducer(price, {
  update_buy_price: (state, action) => {
    return action.payload;
  },
});

export default gold_buy_price;
